import { render, staticRenderFns } from "./file.vue?vue&type=template&id=4d85e4b0&scoped=true&lang=html&"
import script from "./file.vue?vue&type=script&lang=js&"
export * from "./file.vue?vue&type=script&lang=js&"
import style0 from "./file.vue?vue&type=style&index=0&id=4d85e4b0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d85e4b0",
  null
  
)

component.options.__file = "file.vue"
export default component.exports